var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbbLightswitcherLight = function SvgAbbLightswitcherLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#abb_lightswitcher-light_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__b)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC582",
    d: "M43.884 53.365c2.253 4.46-28.85 1.909-35.271 1.909-6.422 0-2.326-3.681-2.326-8.222 0-3.67 25.194-4.111 33.72-.881 6.422 0 1.057 1.615 3.877 7.194"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__c)",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F48400",
    d: "M39.384 48.17c0 4.33 5.142 8.309-2.92 8.309C28.404 56.479 8 58.604 8 54.274S16.725 43 24.787 43s14.597.84 14.597 5.17"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__d)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#abb_lightswitcher-light_svg__e)",
    d: "m3.915 52.499-.915-4c1.194-.787 10.014.77 10.873-.174.86-.945 18.978.393 27.93 1.18L46 48.5l-1.372 3.99c-4.163 16.302-36.55 19.647-40.713.01"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 48.36,
    fill: "#FF9F46",
    rx: 24,
    ry: 7.233
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.139 9.009h1.714v9.176h-1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#abb_lightswitcher-light_svg__f)",
    stroke: "#FF8122",
    d: "M24.645 52.149h-1.286c-4.322 0-7.833-3.533-7.833-7.9 0-1.33.347-2.635 1.004-3.788l2.306-4.045c.149-.26.236-.552.255-.851l.016-.242a5.1 5.1 0 0 1 1.575-3.367l6.248-.562.12.12c.444.443.863 1.123 1.178 1.879.314.755.506 1.542.526 2.182.01.32.104.631.272.904l2.318 3.773a7.64 7.64 0 0 1 1.129 3.94c.034 4.389-3.485 7.957-7.828 7.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#abb_lightswitcher-light_svg__g)",
    stroke: "#FF8122",
    d: "M24.645 52.149h-1.286c-4.322 0-7.833-3.533-7.833-7.9 0-1.33.347-2.635 1.004-3.788l2.306-4.045c.149-.26.236-.552.255-.851l.016-.242a5.1 5.1 0 0 1 1.575-3.367l6.248-.562.12.12c.444.443.863 1.123 1.178 1.879.314.755.506 1.542.526 2.182.01.32.104.631.272.904l2.318 3.773a7.64 7.64 0 0 1 1.129 3.94c.034 4.389-3.485 7.957-7.828 7.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.71 43.65c.028-.068-.012-.145-.089-.17s-.162.011-.19.08zm3.683-6.572c-.027.506-.3 1.76-.635 3.028-.334 1.268-.72 2.522-.966 3.028l.272.106c.259-.532.65-1.81.984-3.073.332-1.263.613-2.542.643-3.076zm-1.601 6.056c-.375.77-1.032 1.113-1.517 1.15-.245.017-.426-.043-.524-.14-.092-.092-.14-.249-.04-.493l-.28-.09c-.124.306-.087.575.099.76.18.18.467.25.77.227.608-.045 1.353-.461 1.764-1.308z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M23.56 38.324c-.023 1.009.346 4.999-.065 5.956-.34.792-.978.916-1.042.488.078-.117.141-.104.277 0 .17.129 0 .223-.085.407M24.44 38.324c.022 1.009-.347 4.999.064 5.956.34.792.978.916 1.042.488-.078-.117-.141-.104-.277 0-.17.129 0 .223.085.407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.29 43.65c-.029-.068.011-.145.088-.17.078-.025.163.011.19.08zm-3.684-6.572c.028.506.301 1.76.635 3.028s.721 2.522.967 3.028l-.272.106c-.259-.532-.651-1.81-.984-3.073s-.614-2.542-.643-3.076zm1.602 6.056c.374.77 1.032 1.113 1.517 1.15.244.017.426-.043.524-.14.091-.092.14-.249.04-.493l.28-.09c.124.306.087.575-.099.76-.18.18-.468.25-.77.227-.609-.045-1.353-.461-1.764-1.308z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-light_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.306 31.473h7.388a.32.32 0 0 0 .328-.312.32.32 0 0 0-.328-.311h-7.389a.32.32 0 0 0-.328.311.32.32 0 0 0 .328.312"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M20.306 31.473h7.388a.32.32 0 0 0 .328-.312.32.32 0 0 0-.328-.311h-7.389a.32.32 0 0 0-.328.311.32.32 0 0 0 .328.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M27.694 31.473v-1h-7.389v2h7.389zm-7.389 0v-1a.68.68 0 0 1 .672.688h-2c0 .774.645 1.312 1.328 1.312zm-.328-.312h1a.68.68 0 0 1-.672.689v-2c-.683 0-1.328.538-1.328 1.311zm.328-.311v1h7.389v-2h-7.389zm7.389 0v1a.68.68 0 0 1-.672-.689h2c0-.773-.645-1.311-1.328-1.311zm.328.311h-1a.68.68 0 0 1 .672-.688v2c.683 0 1.328-.538 1.328-1.312z",
    mask: "url(#abb_lightswitcher-light_svg__h)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-light_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.596 31.473h7.426v-.623h-7.426z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M20.596 31.473h7.426v-.623h-7.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M28.022 31.473v1h1v-1zm-7.426 0h-1v1h1zm0-.623v-1h-1v1zm7.426 0h1v-1h-1zm0 .623v-1h-7.426v2h7.426zm-7.426 0h1v-.623h-2v.623zm0-.623v1h7.426v-2h-7.426zm7.426 0h-1v.623h2v-.623z",
    mask: "url(#abb_lightswitcher-light_svg__i)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-light_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.596 30.227h7.426v-.623h-7.426z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M20.596 30.227h7.426v-.623h-7.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M28.022 30.227v1h1v-1zm-7.426 0h-1v1h1zm0-.623v-1h-1v1zm7.426 0h1v-1h-1zm0 .623v-1h-7.426v2h7.426zm-7.426 0h1v-.623h-2v.623zm0-.623v1h7.426v-2h-7.426zm7.426 0h-1v.623h2v-.623z",
    mask: "url(#abb_lightswitcher-light_svg__j)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-light_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.977 28.98h8.045v-.622h-8.045z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M19.977 28.98h8.045v-.622h-8.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M28.022 28.98v1h1v-1zm-8.045 0h-1v1h1zm0-.622v-1h-1v1zm8.045 0h1v-1h-1zm0 .623v-1h-8.045v2h8.045zm-8.045 0h1v-.623h-2v.623zm0-.623v1h8.045v-2h-8.045zm8.045 0h-1v.623h2v-.623z",
    mask: "url(#abb_lightswitcher-light_svg__k)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-light_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.596 27.736h7.426v-.623h-7.426z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M20.596 27.736h7.426v-.623h-7.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M28.022 27.736v1h1v-1zm-7.426 0h-1v1h1zm0-.623v-1h-1v1zm7.426 0h1v-1h-1zm0 .622v-1h-7.426v2h7.426zm-7.426 0h1v-.622h-2v.622zm0-.622v1h7.426v-2h-7.426zm7.426 0h-1v.622h2v-.622z",
    mask: "url(#abb_lightswitcher-light_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    stroke: "#1F1F1F",
    d: "M20.693 25.99a.85.85 0 0 1 .61-.246h5.393c.252 0 .464.099.61.246zM19.897 30.35l-.003-.003a.2.2 0 0 1-.036-.12c0-.06.02-.1.036-.12l.004-.003h8.203l.004.004a.2.2 0 0 1 .036.119c0 .06-.02.102-.036.12l-.003.003z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-light_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.903 29.605h8.194c.3 0 .544-.14.544-.312s-.244-.311-.544-.311h-8.194c-.3 0-.545.139-.545.311s.244.312.545.312"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M19.903 29.605h8.194c.3 0 .544-.14.544-.312s-.244-.311-.544-.311h-8.194c-.3 0-.545.139-.545.311s.244.312.545.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M28.097 29.605v-1h-8.194v2h8.194zm-8.194 0v-1q.002 0 .023.003a.3.3 0 0 1 .088.037c.05.029.344.22.344.648h-2c0 .6.416.947.664 1.088.275.158.589.224.881.224zm-.545-.312h1c0 .428-.294.62-.344.648a.3.3 0 0 1-.088.037q-.021.005-.023.004v-2c-.292 0-.606.065-.881.223-.248.141-.664.489-.664 1.088zm.545-.311v1h8.194v-2h-8.194zm8.194 0v1q-.002.001-.024-.004a.3.3 0 0 1-.088-.037.74.74 0 0 1-.344-.648h2c0-.6-.416-.947-.663-1.088a1.8 1.8 0 0 0-.881-.223zm.544.311h-1c0-.427.294-.62.344-.648a.3.3 0 0 1 .088-.037q.023-.004.024-.003v2c.292 0 .606-.066.881-.224.247-.141.663-.489.663-1.088z",
    mask: "url(#abb_lightswitcher-light_svg__m)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-light_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.88 28.359h8.24c.288 0 .521-.14.521-.312s-.233-.311-.52-.311h-8.242c-.287 0-.52.139-.52.311s.233.311.52.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M19.88 28.359h8.24c.288 0 .521-.14.521-.312s-.233-.311-.52-.311h-8.242c-.287 0-.52.139-.52.311s.233.311.52.311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M28.12 28.359v-1h-8.24v2h8.24zm-8.24 0v-1c.005 0 .059-.001.144.05a.74.74 0 0 1 .334.638h-2c0 .577.386.927.64 1.079.274.163.588.232.881.232zm-.522-.312h1c0 .405-.269.6-.334.638-.085.051-.139.05-.145.05v-2c-.293 0-.607.07-.881.233-.254.152-.64.502-.64 1.079zm.521-.311v1h8.241v-2h-8.24zm8.241 0v1c-.005 0-.059 0-.144-.05a.74.74 0 0 1-.335-.639h2c0-.577-.386-.927-.64-1.079a1.7 1.7 0 0 0-.88-.232zm.521.311h-1c0-.405.27-.6.335-.638.085-.051.139-.05.144-.05v2c.294 0 .608-.07.882-.233.253-.152.64-.502.64-1.079z",
    mask: "url(#abb_lightswitcher-light_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    stroke: "#1F1F1F",
    d: "m19.897 27.236-.003-.003a.2.2 0 0 1-.036-.12c0-.06.02-.101.036-.12l.004-.004h8.203l.004.004a.2.2 0 0 1 .036.12c0 .06-.02.101-.036.12l-.003.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "m27.403 30.85-1.856 3.425-.62 1.869-.345 2.572c-.042.296-1.015.313-1.11.02l-.029-.087-.297-2.78a3.8 3.8 0 0 0-.519-1.512l-2.031-3.46 5.999-.03"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__o)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.944 42.658c-2.462 0-4.458.942-4.458 2.104s1.996 2.104 4.458 2.104 4.458-.942 4.458-2.104-1.996-2.104-4.458-2.104"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 16,
    d: "M27.606 44.803c-1.21-.177-2.09.22-2.368.34-.266-.08-.892-.44-1.354-.44s-.822.38-.995.46c-.093-.033-.454-.336-.756-.4-.303-.065-1.334-.027-1.811 0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 8,
    d: "M27.606 44.803c-1.21-.177-2.09.22-2.368.34-.266-.08-.892-.44-1.354-.44s-.822.38-.995.46c-.093-.033-.454-.336-.756-.4-.303-.065-1.334-.027-1.811 0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 5,
    d: "M27.606 44.803c-1.21-.177-2.09.22-2.368.34-.266-.08-.892-.44-1.354-.44s-.822.38-.995.46c-.093-.033-.454-.336-.756-.4-.303-.065-1.334-.027-1.811 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M0 47.927c3.027-3.138 12.564-5.429 23.86-5.429 11.672 0 21.465 2.446 24.14 5.745C46.932 30.08 36.59 15.83 23.99 15.83 11.463 15.831 1.168 29.916 0 47.927",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__s)",
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#abb_lightswitcher-light_svg__t)",
    d: "m5 52.14 2.171-8.129c1.135-.293 9.687 5.16 10.504 4.808s11.054.6 16.888-.543H43v3.864c-20.629 12.622-34.2 4.886-38 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.139 0h1.714v9.009h-1.714z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__u)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#abb_lightswitcher-light_svg__v)",
    d: "M3.915 51 3 48.331c1.194-.524 10.014.514 10.873-.115.86-.63 18.978.262 27.93.786l4.197-.67-1.372 2.66c-4.163 10.867-36.55 13.098-40.713.006"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-light_svg__w)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#abb_lightswitcher-light_svg__x)",
    d: "M3.915 50.5 3 48.276c1.194-.437 10.014.428 10.873-.097.86-.524 18.978.219 27.93.656L46 48.277l-1.372 2.216C40.465 59.55 8.078 61.41 3.915 50.5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__b",
    width: 51.4,
    height: 24.4,
    x: -1.2,
    y: 37.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 3.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__c",
    width: 42.8,
    height: 23.8,
    x: 3.1,
    y: 38.1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 2.45
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__d",
    width: 51.6,
    height: 26.6,
    x: -1.3,
    y: 43.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 2.15
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__o",
    width: 71.517,
    height: 66.808,
    x: -11.814,
    y: 11.358,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 15.65
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__p",
    width: 40.489,
    height: 47.102,
    x: 3.271,
    y: 21.702,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 7.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__q",
    width: 27.285,
    height: 27.981,
    x: 10.498,
    y: 31.102,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 4.8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__r",
    width: 36.785,
    height: 34.661,
    x: 5.682,
    y: 27.702,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 7.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__s",
    width: 52.6,
    height: 29.6,
    x: -2.3,
    y: 36.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 3.65
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__u",
    width: 51.6,
    height: 20.6,
    x: -1.3,
    y: 43.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 2.15
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-light_svg__w",
    width: 51.6,
    height: 18.6,
    x: -1.3,
    y: 43.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27671",
    stdDeviation: 2.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abb_lightswitcher-light_svg__e",
    x1: 25.646,
    x2: 26.032,
    y1: 48,
    y2: 64.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE861F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4911C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abb_lightswitcher-light_svg__t",
    x1: 24,
    x2: 24,
    y1: 71.903,
    y2: 49.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E4D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abb_lightswitcher-light_svg__v",
    x1: 25.646,
    x2: 25.817,
    y1: 48,
    y2: 58.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE861F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4911C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abb_lightswitcher-light_svg__x",
    x1: 25.646,
    x2: 25.765,
    y1: 48,
    y2: 57.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE861F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4911C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "abb_lightswitcher-light_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.49268 -17.18374 14.6159 -.41906 24.032 42.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "abb_lightswitcher-light_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.49268 -17.18374 14.6159 -.41906 24.032 42.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "abb_lightswitcher-light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v80H0z"
  })))));
};
export default SvgAbbLightswitcherLight;